<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Escalate Support Group</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div>

    <label class="font-13"> Escalation From Support Group</label>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectForSupportGroup"
              (change)="forSupportGroupChange($event.target.selectedIndex)">
        <option *ngFor="let forGroup of forSupportGroup" [value]="forGroup.id">{{forGroup.name}}</option>
      </select>
    </div>

    <label class="font-13"> Escalation To Support Group</label>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectToSupportGroup"
              (change)="toSupportGroupChange($event.target.selectedIndex)">
        <option *ngFor="let toGroup of toSupportGroup" [value]="toGroup.id">{{toGroup.name}}</option>
      </select>
    </div>

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
              (change)="onPriorityChange($event.target.selectedIndex)">
        <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
      </select>
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="additionalEmail"
             placeholder="Additional email for escalation">
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="escalationEmailTime"
             placeholder="Escalation mail time( in min)">
    </div>

    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="subject" placeholder="Subject" required></textarea>
    </div>

    <ck-editor name="editor1" [(ngModel)]="editorValue" skin="moono-lisa" language="en" [fullPage]="true" placeholder="Template body"></ck-editor>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
